import { SI, NO, SIN_DATO, tresEstados } from "../../shared/tresEstados";

/* La casilla de lona y de puerta. Verde = sí, gris = no.
 *
 * ── Y HAY UN TERCER ESTADO, QUE ES EL QUE MÁS IMPORTA HOY ────────────────
 *
 * El pedido fue de dos: «gris (como apagado) = no, verde semáforo = sí». El
 * problema es que **678 de 679 furgones no tienen el dato cargado**, así que
 * con dos estados la flota entera se dibujaría gris — o sea afirmando que
 * ningún furgón tiene lona, sobre una columna que nadie llenó todavía.
 *
 * Eso no es un detalle de estilo: es la diferencia entre «hay 600 furgones sin
 * lona» y «hay 600 que nadie miró». La primera manda a comprar lonas.
 *
 * Así que el verde y el gris son EXACTAMENTE los que se pidieron, y lo que no
 * se cargó va **hueco** —contorno punteado, sin relleno— que no se confunde
 * con ninguno de los dos y se lee como lo que es: falta. Es la regla de la
 * lona, del psicofísico sin fecha y de las 86 unidades que no reportaron urea:
 * **«no sabemos» no se dice como «no»**.
 *
 * ── EL COLOR NO ES LO ÚNICO QUE LO DICE ──────────────────────────────────
 *
 * Verde y gris a un centímetro se distinguen mal en una pantalla al sol, y
 * hay quien no los distingue nunca. Va un símbolo adentro (✓ / ·) y el
 * `title` + `aria-label` dicen la palabra completa — el color alcanza para
 * ESCANEAR la columna, no para identificar una fila.
 */

const COMO = {
  [SI]: { clase: "si", signo: "✓", dice: "Sí" },
  [NO]: { clase: "no", signo: "", dice: "No" },
  [SIN_DATO]: { clase: "sindato", signo: "", dice: "Sin dato" },
};

export default function Casilla({ valor, que = "" }) {
  const e = tresEstados(valor);
  const c = COMO[e];
  const dice = que ? `${que}: ${c.dice}` : c.dice;
  return (
    <span
      className={"casilla casilla--" + c.clase}
      title={dice}
      aria-label={dice}
      role="img"
    >
      {c.signo}
    </span>
  );
}
